/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import { createAction } from 'redux-actions';
import { createTypesMap } from './types';

export const types = createTypesMap('roadtest', [
  'getTimes',
  'getDevice',
  'getGateway',
  'getGpsColor',
  'getRadius',
  'updateGps',
  'startDwnld',
]);

const getTimes = createAction(types.getTimes, times => times);
const getDevice = createAction(types.getDevice, device => device);
const getGateway = createAction(types.getGateway, gateway => gateway);
const getGpsColor = createAction(types.getGpsColor, colors => colors);
const getRadius = createAction(types.getRadius, radius => radius);
const updateGps = createAction(types.updateGps, u => u);
const startDwnld = createAction(types.startDwnld, s => s);

export default {
  getTimes,
  getDevice,
  getGateway,
  getGpsColor,
  getRadius,
  updateGps,
  startDwnld,
};




// WEBPACK FOOTER //
// ./src/redux/actions/roadtest.js